// extracted by mini-css-extract-plugin
module.exports = {"container":"AssessmentDifferences_container__hS4xP","valid":"AssessmentDifferences_valid__Cnstu"};